"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// https://github.com/callemall/material-ui/issues/5070#issuecomment-297088767


var orig = _react2["default"].createElement;

_react2["default"].createElement = function (type, props) {
  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  // only wrap native elements (string-ish `type`) which have an onTouchTap prop
  if (typeof type === "string" && props && props.onTouchTap) {

    var _orig = props.onTouchTap;

    props = (0, _extends3["default"])({}, props, {
      onTouchTap: function onTouchTap(e) {
        e.preventDefault();
        return _orig.apply(this, arguments);
      }
    });
  }

  return orig.call.apply(orig, [this, type, props].concat(children));
};


//////////////////
// WEBPACK FOOTER
// ./program/frontend/react-patch.js
// module id = 353
// module chunks = 0